import { string, addMethod } from 'yup';

export default () => {
  // eslint-disable-next-line func-names
  addMethod(string, 'urlHasProtocol', function () {
    return this.test({
      name: 'urlHasProtocol',
      message: 'Url is missing protocol',
      test: (value = '') => {
        if (value) {
          return value.match(/^https?:\/\//)?.length > 0;
        }

        return true;
      },
    });
  });
};
